import { DatePipe } from '@angular/common';
import {Component,ElementRef,OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { User } from 'src/app/auth/models';
import { JwtService } from 'src/app/auth/services';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { SharedService } from 'src/app/shared/services';
import { IVendorInvoicesReport } from '../../models';
import { VendorInvoicesService } from '../../services';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { InvoiceSearchGlobalFilter, LookupCategory } from '../../../shared/enums/EnumsVMS';

@Component({
  selector: 'app-vendor-invoices',
  templateUrl: './vendor-invoices.component.html',
  styleUrls: ['./vendor-invoices.component.css'],
  providers: [DialogService, ConfirmationService, MessageService]
})
export class VendorInvoicesComponent implements OnInit {

  rangeDates: Date[];
  vendorInvoicesReportForm:FormGroup;
  selectedReports: string[] = [];
  reports: any[];
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  matchModeOptionsForDropdown: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  invoiceReportSearchParam:IGlobalSearchParam;
  showAddRuleButton:boolean = false;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  vendorInvoicesReportList;
  isshowpaginator:boolean=true;
  loggedInUserProfile: User;
  dateRange:Date[];
  minDate: Date;
  maxDate: Date;
  categoryName;
  //reportTypes;
  selectedReportIds;
  selectedReportEditIds;
  selectedReportEditIdsOnChange;
  selectedReportValid: boolean = true;
  timesheetStartDate;
  timesheetEndDate;
  arrAllReportTypes;
  showTable:boolean = false;
  showIneligibleApplicants: boolean = true ;
  vendorInvoiceReport = 'VendorInvoiceReport.xlsx';
  allColumns = [
    { value: 'vendorCompanyName', header: 'Vendor' },
    { value: 'applicantName', header: 'applicant' },
    { value: 'invoiceDate', header: 'Invoice Date' },
    { value: 'verifiedOn', header: 'Verified On' },
    { value: 'verifiedWithin24hrsStatus', header: 'Verified Within 24 Hrs' },
    { value: 'timesheetStartDate', header: 'TS Start Date' },
    { value: 'timesheetEndDate', header: 'TS End Date' },
    { value: 'reportStatusName', header: 'Invoice in DVMS' },
    { value: 'statusName', header: 'Invoice Status' },
    { value: 'invoiceRejectReason', header: 'Rejection Type' },
    { value: 'rejectedByName',  header: 'Rejected By'},
    { value: 'approvedByName', header: 'Approved By' },
    { value: 'unableProcessPaymentByName', header:'Unable to Process Payment By' }
   

  ];
  selectedColumns = [
    { value: '#', header: '#' },
    { value: 'vendorCompanyName', header: 'Vendor' },
    { value: 'applicantName', header: 'applicant' },
    { value: 'invoiceDate', header: 'Invoice Date' },
    { value: 'verifiedOn', header: 'Verified On' },
    { value: 'verifiedWithin24hrsStatus', header: 'Verified Within 24 Hrs' },
    { value: 'timesheetStartDate', header: 'TS Start Date' },
    { value: 'timesheetEndDate', header: 'TS End Date' },
    { value: 'reportStatusName', header: 'Invoice in DVMS' },
    { value: 'statusName', header: 'Invoice Status' },
    { value: 'invoiceRejectReason', header: 'Rejection Type' },
  ];
  reportTypes = [
    {
      "description":"All"
    },
    {
     "description": "Invoice Received"
    },
    {
     "description": "Invoice Not Received"
    }
  ];
  vendorInvocieSpinner = 'vendorInvoiceSpinner';
  selectedStatus:any;
  selectedRejectType:any;
  timesheetStartDateFilterValue: any;
  timesheetEndDateFilterValue: any;
  invoiceDateFilterValue: any;
  verifiedOnFilterValue: any;
  @ViewChild('dt2', { static: true }) table: any;
  invoiceStatus: ILookupCategory;
  verifiedStatus: ILookupCategory;
  allInvoiceRejectReason: ILookupCategory;
  allInvoiceRejectReasonFilter: ILookupCategory;
  arrInvoiceStatus;
  arrVerifiedStatus;
  arrAllInvoiceRejectReason;
  invoiceRejectReasonId:any;
  selectedInvoiceRejectReason;
  public selectedInvoiceRejectReasonId: Array<any> = [];
  reportStatusValues:any;
  selectedReportStatus:any;
  selectedInvoiceVerifiedStatus:any;
  showToggle:boolean;
  timesheetStartSelectedDate: Date = new Date();

  constructor(
    private vendorInvoicesService: VendorInvoicesService,
    public sharedService: SharedService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private jwtService: JwtService,
    private router: Router
  ) { 
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
  }
 
  ngOnInit(): void {
    this.checkViewPermission();
    this.reactiveForm();
    //this.getReportTypes();
    this.maxDate = new Date();
    this.timesheetStartSelectedDate = new Date();
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";

    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.matchModeOptionsForDropdown = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
    ];
  

    this.filterCondition=[
      {fieldName:"vendorCompanyName",type:"basic"},
      {fieldName:"applicantName",type:"basic"},
      {fieldName:"invoiceDate",type:"date"},
      {fieldName:"verifiedOn",type:"date"},
      {fieldName:"verifiedWithin24hrsStatus",type:"dropdown"},      
      {fieldName:"timesheetStartDate",type:"date"},
      {fieldName:"timesheetEndDate",type:"date"},
      {fieldName:"reportStatusName",type:"dropdown"},
      {fieldName:"statusName",type:"dropdown"},
      {fieldName:"invoiceRejectReason",type:"dropdown"},
      {fieldName:"rejectedByName",type:"basic"},
      {fieldName:"approvedByName",type:"basic"},
      {fieldName:"unableProcessPaymentByName",type:"basic"},


    ];

    this.reportStatusValues = [
      { description: 'All', id: 'All' },
      { description: 'Invoice Received', id: 'Received' },
      { description: 'Invoice Not Received', id: 'Not Received' }
    ];
    //this.getVendorInvoiceReport();
    //this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
        this.getInvoiceStatus();
        this.getInvoiceRejectReason();
        this.getInvoiceVerifiedWithin24hrsStatus();

   }

   reactiveForm() {
    this.vendorInvoicesReportForm = this.formBuilder.group({
      timesheetStartDate: new FormControl(null, [Validators.required]),
      timesheetEndDate: new FormControl(null, [Validators.required]),
    })
  }
  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }
   checkViewPermission() {
    var permission =this.jwtService.getLoggedInUserProfile();
    var allowedUser = this.sharedService.isMspUser();
    if(permission ==0 || allowedUser == false || allowedUser == undefined)
    {
     this.router.navigateByUrl('/login');
    }
  }

  getReportTypes() {
    this.categoryName = 'Vendor Invoice Report';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.reportTypes = data;
      this.arrAllReportTypes = this.reportTypes;
       this.arrAllReportTypes.push({
        description: "All",
       lookupOrder: 0,
      });
      this.arrAllReportTypes.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.reportTypes = this.arrAllReportTypes;
    });
  }

  onChangeShowIneligibleApplicants(value) {
    
    this.showIneligibleApplicants = value.checked;
   console.log('this.showIneligibleApplicants - ' + this.showIneligibleApplicants);
  }
  // getReportTypesOnChange(event) {
  //   if (this.selectedReportIds.length == 0) {
  //     //this.selectedItems = '“You may select multiple certifications.”';
  //     this.selectedReportValid = true;
  //   }
  //   else {
  //     this.selectedReportValid = false;
  //   }
  //     if (this.selectedReportEditIds != '' || this.selectedReportEditIds != undefined) {
  //       this.selectedReportEditIds = '';
  //       console.log('1');
  //       for (var m = 0; m < event.value.length; m++) {
  //         if(this.selectedReportEditIds == '')
  //         {
  //           this.selectedReportEditIds = event.value[m].lookupOrder;
  //         }
  //         else{
  //           this.selectedReportEditIds = this.selectedReportEditIds + ',' + event.value[m].lookupOrder;
  //         }
  //         //this.selectedReportEditIds = this.selectedReportEditIds + ',' + event.value[m].lookupOrder;
  //       }

  //     }
  //     else {
  //       if (event.value.length == 1) {
  //         console.log('2');
  //         this.selectedReportEditIds = event.value[0].lookupOrder;
  //       }
  //       else {
  //         console.log('3');
  //         this.selectedReportEditIds = "";
  //         for (var k = 0; k < event.value.length; k++) {
  //           if(this.selectedReportEditIds == "")
  //           {
  //             this.selectedReportEditIds = event.value[k].lookupOrder;
  //           }
  //           this.selectedReportEditIds = this.selectedReportEditIds + ',' + event.value[k].lookupOrder;         }
  //       }

  //     }
    
    
  // }
  getReportTypesOnChange(event) {
    this.selectedReportEditIdsOnChange = event.value.description;
  }
  onSelectStartDate(event) {
  // this.maxDate = new Date(this.datePipe.transform(event, 'yyyy-MM-dd'));
  const localDateString = event.toLocaleDateString('En-en');
  this.timesheetStartSelectedDate = new Date(localDateString);
  var selectedTimesheetStartDate = new Date(this.timesheetStartSelectedDate);
  this.timesheetStartSelectedDate = selectedTimesheetStartDate;
  this.vendorInvoicesReportForm.controls['timesheetEndDate'].setValue(undefined);
  }

  loadVendorInvoiceList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getVendorInvoiceReport();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
   
    if(this.filters["createdOn"] != undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
  }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getVendorInvoiceReport();
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  
  generateReport({ value }: { value: IVendorInvoicesReport },table:Table) 
  {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.timesheetStartDateFilterValue = undefined;
    this.timesheetEndDateFilterValue = undefined;
    this.invoiceDateFilterValue = undefined;
    this.verifiedOnFilterValue = undefined;
    this.selectedRejectType ="";
    this.selectedStatus ="";
    this.selectedReportStatus = "";
    this.selectedInvoiceVerifiedStatus = "";
    this.timesheetStartDate = value.timesheetStartDate;
    this.timesheetEndDate= value.timesheetEndDate;
    this.selectedReportEditIds = this.selectedReportEditIdsOnChange;
    //console.log(this.showIneligibleApplicants);
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid }); 
    //this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(value.timesheetStartDate,"MM-dd-yyyy")});
    //this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(value.timesheetEndDate,"MM-dd-yyyy")}); 
    
    this.showTable = true;
   
 // setTimeout(() => {
    this.getVendorInvoiceReport();
  //  }, 2000);
    //this.getVendorInvoiceReport();
  }
  getVendorInvoiceReport()
  {
    // if(this.selectedReportEditIds == undefined)
    // {

    // }
    if(this.timesheetStartDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetStartDate,"MM-dd-yyyy")});
    }
    if(this.timesheetEndDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetEndDate,"MM-dd-yyyy")}); 
    }
    if(this.selectedReportEditIds !=undefined)
    {
      this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:this.selectedReportEditIds });  
    }
    else
    {
      this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:"All" });  
    }
    if(this.showIneligibleApplicants == true)
    {
      this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"true" });  
    }
    else
    {
      this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"false" });  
    }
    
  
    this.invoiceReportSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       console.log('parma',this.invoiceReportSearchParam)
       this.spinner.show();
    this.vendorInvoicesService.searchInvoiceReport(this.invoiceReportSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.vendorInvoicesReportList =data;
      console.log('vn',this.vendorInvoicesReportList);
      this.isshowpaginator=this.vendorInvoicesReportList.length>0?true:false;
      this.totalRecords = (this.vendorInvoicesReportList === null || this.vendorInvoicesReportList === undefined || this.vendorInvoicesReportList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });
  }
  clear(table:Table)
  {
  //  console.log(table);
    table.clear();
    this.reactiveForm();
    this.selectedReportIds="";
    this.selectedReportEditIds =undefined;
    this.selectedReportEditIdsOnChange =undefined;
    this.appliedFilters = [];
    this.vendorInvoicesReportList =[];
    this.isshowpaginator=false;
    this.timesheetStartDateFilterValue = undefined;
    this.timesheetEndDateFilterValue = undefined;
    this.invoiceDateFilterValue = undefined;
    this.verifiedOnFilterValue = undefined;
    this.selectedInvoiceVerifiedStatus ="";
    this.selectedRejectType ="";
    this.selectedStatus ="";
    this.selectedReportStatus = "";
    this.selectedInvoiceVerifiedStatus = "";
    this.showIneligibleApplicants=true;
    this.timesheetStartSelectedDate = new Date();
    // this.pageNo =1;
    // this.pageSize =10;
    // this.oldPageNo =1;
    // this.oldPageSize =10;
    // this.totalRecords = 0;
    // this.sortField = 'createdOn';
    // this.sortOrder = 'desc';
    // this.oldSortField = 'createdOn';
    // this.oldSortOrder = 'desc';
    this.showTable = false;
  }
  // exportVendorInvoiceReport(): void {
  //   console.log('export');
  //   let element = document.getElementById('vendorInvoice-report');
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //   XLSX.writeFile(wb, this.vendorInvoiceReport);
  // }

  exportVendorInvoiceReport()
  {
    if(this.timesheetStartDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetStartDate,"MM-dd-yyyy")});
    }
    if(this.timesheetEndDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetEndDate,"MM-dd-yyyy")}); 
    }
    if(this.selectedReportEditIds !=undefined)
    {
      this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:this.selectedReportEditIds });  
    }
    else
    {
      this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:"All" });  
    }
    if(this.showIneligibleApplicants == true)
    {
      this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"true" });  
    }
    else
    {
      this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"false" });  
    }

    this.applyFilter();
    this.invoiceReportSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show();
    this.vendorInvoicesService.exportInvoiceReport(this.invoiceReportSearchParam).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob],"VendorInvoiceReport.xlsx", { type: res.body.type });
      fs.saveAs(file);
      });
      this.spinner.hide();
  }

  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  applyFilter() {
    //  console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is " + [this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            // for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            //   if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
            //     this.appliedFilters.push({
            //       field: this.filterCondition[i].fieldName,
            //       matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
            //       value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value, "MM-dd-yyyy")
            //     })
            // }

            if (this.filterCondition[i].fieldName == "verifiedOn") {
              this.dateFilterValueSet(this.verifiedOnFilterValue, "verifiedOn")
            }

            if (this.filterCondition[i].fieldName == "invoiceDate") {
              this.dateFilterValueSet(this.invoiceDateFilterValue, "invoiceDate")
            }

            if (this.filterCondition[i].fieldName == "timesheetStartDate") {
              this.dateFilterValueSet(this.timesheetStartDateFilterValue, "timesheetStartDate")
            }

            if (this.filterCondition[i].fieldName == "timesheetEndDate") {
              this.dateFilterValueSet(this.timesheetEndDateFilterValue, "timesheetEndDate")
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        if(this.filters['statusName'] !==undefined)
        {
          if (this.filters['statusName'][0].value !== null && this.filters['statusName'][0].value != 0) {
            this.getSelectedInvoiceStatus(this.invoiceStatus,this.filters['statusName'][0].value)
          }
          else{
            this.selectedStatus= "";
          }
        }
        if(this.filters['invoiceRejectReason'] !==undefined)
        {
          if (this.filters['invoiceRejectReason'][0].value !== null && this.filters['invoiceRejectReason'][0].value != 0) {
            this.getSelectedRejectType(this.allInvoiceRejectReasonFilter,this.filters['invoiceRejectReason'][0].value)
          }
          else{
            this.selectedRejectType= "";
          }
        }
        if(this.filters['reportStatusName'] !==undefined)
        {
          if (this.filters['reportStatusName'][0].value !== null && this.filters['reportStatusName'][0].value != 0) {
            this.getSelectedReportStatus(this.reportStatusValues,this.filters['reportStatusName'][0].value)
          }
          else{
            this.selectedReportStatus= "";
          }
        }

        if(this.filters['verifiedWithin24hrsStatus'] !==undefined)
        {
          if (this.filters['verifiedWithin24hrsStatus'][0].value !== null && this.filters['verifiedWithin24hrsStatus'][0].value != 0) {
            this.getSelectedInvoiceVerifiedStatus(this.verifiedStatus,this.filters['verifiedWithin24hrsStatus'][0].value)
          }
          else{
            this.selectedInvoiceVerifiedStatus= "";
          }
        }
      }
      if(this.timesheetStartDate !=undefined)
      {
        this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetStartDate,"MM-dd-yyyy")});
      }
      if(this.timesheetEndDate !=undefined)
      {
        this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(this.timesheetEndDate,"MM-dd-yyyy")}); 
      }
      if(this.selectedReportEditIds !=undefined)
      {
        this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:this.selectedReportEditIds });  
      }
      else
      {
        this.appliedFilters.push({ field:"reportType", matchMode:"custom-equals", value:"All" });  
      }
      if(this.showIneligibleApplicants == true)
      {
        this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"true" });  
      }
      else
      {
        this.appliedFilters.push({ field:"showInEligible", matchMode:"custom-equals", value:"false" });  
      }
      
    
      this.invoiceReportSearchParam = 
         {
           pageNo:this.pageNo,
           pageSize:this.pageSize,
           sortField:this.sortField,
           appliedFilters:this.appliedFilters,
           searchGlobalFilter: this.searchGlobalFilter,
           sortOrder:this.sortOrder
         };
       //  console.log('parma',this.invoiceReportSearchParam)
         this.spinner.show();
      this.vendorInvoicesService.searchInvoiceReport(this.invoiceReportSearchParam).subscribe((data: any) => {
        this.appliedFilters = [];
        this.vendorInvoicesReportList =data;
       // console.log('vn',this.vendorInvoicesReportList);
        this.isshowpaginator=this.vendorInvoicesReportList.length>0?true:false;
        this.totalRecords = (this.vendorInvoicesReportList === null || this.vendorInvoicesReportList === undefined || this.vendorInvoicesReportList.length <= 0 )? 0 : data[0].totalCount;
        console.log(this.totalRecords);
        this.spinner.hide();
       });
    }
  }

  invoiceDateFilterData(e: any) {
    this.invoiceDateFilterValue = e;
    this.applyFilterNew();
  }

  verifiedOnFilterData(e: any) {
    this.verifiedOnFilterValue = e;
    this.applyFilterNew();
  }

  timesheetStartDateFilterData(e: any) {
    this.timesheetStartDateFilterValue = e;
    this.applyFilterNew();
  }

  timesheetEndDateFilterData(e: any) {
    this.timesheetEndDateFilterValue = e;
    this.applyFilterNew();
  }


  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datePipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }

  getSelectedInvoiceVerifiedStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.lookupOrder == id);
      this.selectedInvoiceVerifiedStatus= tempStatus[0].description
    }
  }


  getSelectedInvoiceStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.lookupOrder == id);
      this.selectedStatus= tempStatus[0].description
    }
  }
  getSelectedRejectType(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.lookupOrder == id);
      this.selectedRejectType= tempStatus[0].description
    }
  }
  getSelectedReportStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedReportStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }
  getInvoiceStatus() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InvoiceStatus).subscribe((data: any) => {
      this.invoiceStatus = data;
      this.invoiceStatus = data.filter(item => item.description !== 'Invoice Number Updated' && item.description !== 'Mismatch Column Updated' && item.description !== 'Payment In Progress' && item.description !== 'Invoice Adjusted' );
      this.arrInvoiceStatus = this.invoiceStatus;
      this.arrInvoiceStatus.push({
        categoryId: 0, createdBy: 0, createdByUser: null, createdOn: null, description: "All", isActive: true,
        lookupCategory: null,
        lookupId: 0,
        lookupOrder: 0,
        modifiedBy: 0,
        modifiedByUser: null,
        modifiedOn: null
      });
      this.arrInvoiceStatus.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.invoiceStatus = this.arrInvoiceStatus;
    });
  }

  getInvoiceVerifiedWithin24hrsStatus() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InvoiceVerifyWithin24HoursStatus).subscribe((data: any) => {
      this.verifiedStatus = data;
   
      this.arrVerifiedStatus.push({
        categoryId: 0, createdBy: 0, createdByUser: null, createdOn: null, description: "All", isActive: true,
        lookupCategory: null,
        lookupId: 0,
        lookupOrder: 0,
        modifiedBy: 0,
        modifiedByUser: null,
        modifiedOn: null
      });
      this.arrVerifiedStatus.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.verifiedStatus = this.arrVerifiedStatus;
    });
  }
  getInvoiceRejectReason() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InvoiceRejectReason).subscribe((data: any) => {
      this.allInvoiceRejectReason = data;
      this.allInvoiceRejectReason = data.filter(item => item.description !== null );
      this.arrAllInvoiceRejectReason = this.allInvoiceRejectReason;
      this.arrAllInvoiceRejectReason.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.allInvoiceRejectReason = this.arrAllInvoiceRejectReason;

      //for filters
      let filterValue = data.filter(item => item.description !== null );
      filterValue.push({
        categoryId: 0, createdBy: 0, createdByUser: null, createdOn: null, description: "All", isActive: true,
        lookupCategory: null,
        lookupId: 0,
        lookupOrder: 0,
        modifiedBy: 0,
        modifiedByUser: null,
        modifiedOn: null
      });
      filterValue.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.allInvoiceRejectReasonFilter = filterValue;
    });
  }

  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.timesheetStartDateFilterValue = undefined;
    this.timesheetEndDateFilterValue = undefined;
    this.invoiceDateFilterValue = undefined;
    this.verifiedOnFilterValue = undefined;
    this.selectedInvoiceVerifiedStatus ="";
    this.selectedRejectType ="";
    this.selectedStatus ="";
    this.selectedReportStatus = "";
    this.getInvoiceStatus();
    this.getInvoiceRejectReason();
    // this.applyFilter();
    this.getVendorInvoiceReport();
  }
}
